import React from 'react';
import { Row, Col, Tag } from 'antd';
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    BellOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
} from '@ant-design/icons';
import { cn } from "../../../../utils/cn";
import CommonCard from "../../../global/card";
import SOURCES from '../../../../utils/constants';
import { formatDateTime } from '../../../../utils/functions';

const EnhancedAlertDetails = ({ data }) => {
    if (!data) return null;

    const { ALERT_VIA_EMAIL, ALERT_VIA_SMS, ALERT_VIA_BOTH } = SOURCES;

    const getIconForField = (label) => {
        const iconMap = {
            "Recipient Name": <UserOutlined />,
            "Email Address": <MailOutlined />,
            "Mobile Number": <PhoneOutlined />,
            "Alert Via": <BellOutlined />,
            "Created On": <CalendarOutlined />,
            "Last Updated": <ClockCircleOutlined />,
        };
        return iconMap[label] || <BellOutlined />;
    };

    const getAlertViaTag = () => {
        let text = data.alertVia;
        let color = "blue";
        if (data.alertVia === ALERT_VIA_BOTH) {
            text = "Email & SMS";
            color = "purple";
        } else if (data.alertVia === ALERT_VIA_SMS) {
            color = "green";
        }
        return <Tag color={color} className="m-0 px-3 py-1 font-medium">{text}</Tag>;
    };

    const DetailItem = ({ label, value, isLast = false, isTag = false }) => (
        <Col span={24} className={cn("border-b border-gray-200 py-4", isLast && "!border-b-0")}>
            <div className="flex justify-between items-center w-full">
                <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                    <span style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }}>
                        {getIconForField(label)}
                    </span>
                    {label}
                </span>
                {isTag ? (
                    value
                ) : (
                    <span className="text-sm font-semibold text-gray-900">
                        {value || "—"}
                    </span>
                )}
            </div>
        </Col>
    );

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa", minHeight: '100%' }}>
            <Row gutter={[24, 24]}>
                <Col span={24}>
                    <CommonCard
                        title={
                            <div className="flex items-center gap-2">
                                <UserOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                                <span style={{ fontSize: "16px", fontWeight: 600 }}>Recipient Details</span>
                            </div>
                        }
                    >
                        <Row>
                            <DetailItem label="Recipient Name" value={data.alertName} />
                            <DetailItem label="Email Address" value={data.alertEmail} />
                            <DetailItem label="Mobile Number" value={data.alertSms} isLast />
                        </Row>
                    </CommonCard>
                </Col>

                <Col span={24}>
                    <CommonCard
                        title={
                            <div className="flex items-center gap-2">
                                <BellOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                                <span style={{ fontSize: "16px", fontWeight: 600 }}>Alert Configuration</span>
                            </div>
                        }
                    >
                        <Row>
                            <DetailItem
                                label="Alert Via"
                                value={getAlertViaTag()}
                                isTag
                            />
                            <DetailItem
                                label="Created On"
                                value={formatDateTime(data.createdAt)}
                            />
                            <DetailItem
                                label="Last Updated"
                                value={formatDateTime(data.updatedAt)}
                                isLast
                            />
                        </Row>
                    </CommonCard>
                </Col>
            </Row>
        </div>
    );
};

export default EnhancedAlertDetails;
